import axios from 'axios'
import { NODE_BASE_URL } from './serviceHelper'
import { blobToBase64, downloadBlob } from '../utility/fileUtil'

export const fileServices = {
  getFile: async (user, fileName, folder = 'files') => {
    return await axios.get(`${NODE_BASE_URL}/data-entry/file/${fileName}?folder=${folder}`, {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
      responseType: 'blob',
    })
  },
  getBase64: async (user, filename, folder = 'files') => {
    try {
      const blob = await (await fileServices.getFile(user, filename, folder)).data

      return await blobToBase64(blob)
    } catch (error) {
      return error
    }
  },

  downloadFile: async (user, fileName, folder = 'files') => {
    const data = (
      await axios.get(`${NODE_BASE_URL}/data-entry/file/${fileName}?folder=${folder}`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        responseType: 'blob',
      })
    ).data
    downloadBlob(data, fileName)
  },

  uploadFile: async (user, file, folder = null) => {
    const formData = new FormData()
    formData.append('file', file)
    const url = folder
      ? `${NODE_BASE_URL}/data-entry/file?folder=${folder}`
      : `${NODE_BASE_URL}/data-entry/file`
    return await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${user.token}`,
      },
    })
  },

  getS3PredefinedUrls: async (user, fileName, folder = 'file') => {
    const result = await axios.get(
      `${NODE_BASE_URL}/data-entry/${folder}/predefined-url/${fileName}`,
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }
    )

    return result.data
  },
}
